import React from "react";

import ReviewItem from "@containers/Reviews/ReviewItem";
import Loading from "@components/Loading";

const ReviewList = ({
  loading,
  reviews,
  reviewsSummary,
  type,
  productId,
  productVariations,
  onEditReview,
}) => {
  if (loading) {
    return <Loading height={150} />;
  }

  return (
    <>
      <ul className="mt-4 p-0">
        {reviews.map((review, i) => (
          <li key={review._id}>
            <div
              className={`py-20px md:py-33px border-gray-1100 ${
                i != 0 ? "border-t" : ""
              }`}
            >
              <ReviewItem
                onEditReview={onEditReview}
                index={i}
                review={review}
                reviewsSummary={reviewsSummary}
                type={type}
                productId={productId}
                productVariation={
                  productVariations && productVariations[review.productSku]
                }
              />
            </div>
          </li>
        ))}
      </ul>
    </>
  );
};

export default ReviewList;
